/**
 * Build time configurations of the api base urls.
 */
let api: {
    /**
     * Specifies the base url of the UserData api.
     */
    userData: string;
};

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
    case "production":
        api = { userData: "https://userdata-v2.gyldendal.dk" };
        break;

    case "staging":
        api = { userData: "https://qa-userdata.gyldendal.dk" };
        break;

    default:
        api = { userData: "https://test-userdata-v2.gyldendal.dk" };
}

export { api };
